import React from "react";
import "./style.css";

import { useNavigate } from "react-router-dom";

// Import images
import baseballImage from "../../../Assets/Images/new/baseball.png";
import basketballImage from "../../../Assets/Images/new/basketball.png";
import soccerImage from "../../../Assets/Images/new/soccer.png";
import footballImage from "../../../Assets/Images/new/football.png";
import trackImage from "../../../Assets/Images/new/track.png";
import golfImage from "../../../Assets/Images/new/golf.png";
import fitnessImage from "../../../Assets/Images/new/fitness.png";
import bowlingImage from "../../../Assets/Images/new/bowling.png";

const SportsGrid = () => {
  const navigate = useNavigate();
  const sports = [
    { name: "Baseball", image: baseballImage, link: "/instruction/baseball" },
    {
      name: "Basketball",
      image: basketballImage,
      link: "/instruction/basketball",
    },
    { name: "Soccer", image: soccerImage, link: "/instruction/soccer" },
    { name: "Football", image: footballImage, link: "/instruction/football" },
    {
      name: "Track & Field",
      image: trackImage,
      link: "/instruction/track-and-field",
    },
    { name: "Golf", image: golfImage, link: "/instruction/golf" },
    { name: "Fitness", image: fitnessImage, link: "/instruction/fitness" },
    { name: "Bowling", image: bowlingImage, link: "/instruction/bowling" },
  ];

  const handleNavigation = (link) => {
    navigate(link);
  };

  return (
    <div className="sports-grid">
      {sports.map((sport, index) => (
        <div
          key={index}
          className="sport-item"
          onClick={() => handleNavigation(sport.link)}
        >
          <div className="image-wrapper">
            <img src={sport.image} alt={sport.name} className="sport-image" />
          </div>
          {/* <p className="sport-name">{sport.name}</p> */}
        </div>
      ))}
    </div>
  );
};

export default SportsGrid;
